import React from 'react'

//css
import './Footer.css'

import logo from '../../assets/images/logo_3_nb.png'

//MUI
import { Box, Container } from '@mui/material'

//Router dom
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <footer className='footer'>
            <Container maxWidth='xl' sx={{ mt: 8, textAlign: 'center' }}>
                <Box>
                    <img src={logo} alt='F+H' className='footer_logo' />
                </Box>
                <Box className='links_footer' sx={{ mt: 8 }}>
                    <span style={{ color: '#fff', textDecoration: 'none' }}>Todos los Derechos Reservados<span> | </span></span>
                    <Link to="/terminos-y-condiciones" style={{ color: '#fff', textDecoration: 'none' }}>Términos y condiciones<span> | </span></Link>
                    <Link to="/aviso-de-privacidad" style={{ color: '#fff', textDecoration: 'none' }}>Aviso de privacidad</Link>
                </Box>
            </Container>
        </footer>
    )
}

export default Footer